<template>
    <div class="dropdown-filter">
        <div class="dropdown-input">
            <TextInput
                addClass="filter-ddl-input"
                :ref="id"
                :errorInfo="errorInfo"
                :inputId="inputId"
                :inputLbl="inputLbl"
                :isHideLabel="false"
                :isShowError="isShowError"
                :isSubmitted="isSubmitted"
                :busText="busText"
                v-show="!isDisable && !isItemSelected"
                v-model="filterInput" />
            <div class="dropdown-selected"
                v-show="!isDisable && isItemSelected"
                @click="resetSelection()">
                {{selectedItem.text}}  
            </div>
            <div class="dropdown-disabled"
                v-show="placeholder && isDisable">
                {{placeholder}}  
            </div>
        </div>
        <div class="dropdown-list"
            v-if="isShowDropdownList && isHaveItem">
            <div class="dropdown-item"
                v-for="(item, index) in dropdownList"
                :key="index"
                v-show="itemVisible(item)"
                @click="selectItem(item)">
                {{item.text}}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// component
import TextInput from '@/components/Input/Text.vue';
export default {
    name: 'DropdownFilter',
    components: {
        TextInput
    },
    props: {
        // v-model
        value: String,
        // props
        addClass: String,
        errorInfo: Object,
        inputId: String,
        inputLbl: Object,
        isDisable: Boolean,
        isShowError: Boolean,
        isSubmitted: Boolean,
        itemList: Array
    },
    computed: {
        isHaveItem: function () {
            let result = false;
            if (this.dropdownList.length > 0) {
                result = this.dropdownList
                    .some(item => {
                        const itemName = item.text.trim().toLowerCase();
                        const inputVal = this.filterInput.trim().toLowerCase();

                        if (inputVal) {
                            return itemName.indexOf(inputVal) >= 0;
                        } else {
                            return true;
                        }
                    });
            }
                
            return result;
        }
    },
    data: function () {
        return {
            customClass: '',
            id: '',
            placeholder: '',

            content: this.value,
            dropdownList: [],
            filterInput: this.value,
            
            isItemSelected: false,
            isShowDropdownList: false,
            selectedItem: {},

            busText: new Vue()
        }
    },
     watch: {
        value: function (newVal) {
            if (!newVal) {
                this.content = '';
                this.filterInput = '';
                this.selectedItem = {};
                this.isItemSelected = false;
            } else {
                this.setSelectedItem(newVal);
            }
        }
    },
    created: function () {
        this.customClass = this.addClass || '';
        this.id = this.inputId;
        this.placeholder = this.inputLbl.placeholder || ''; 
        this.dropdownList = this.itemList || [];
        if (this.content) {
            const filteredItem = this.dropdownList
                .filter(item => {
                    return (item.text == this.content);
                });
            
            if (filteredItem.length > 0) {
                this.selectedItem = filteredItem[0];
                this.isItemSelected = true;
            }
        }
    },
    mounted: function () {
        this.busText.$on('onBlur', this.onTextInputBlur);
        this.busText.$on('onFocus', this.onTextInputFocus);
    },
    methods: {
        // on event
        onTextInputBlur: function () {
            setTimeout(() => {
                this.isShowDropdownList = false;
            }, 300);
        },
        onTextInputFocus: function () {
            this.isShowDropdownList = true;
        },
        // event
        selectItem: function (item) {
            this.selectedItem = item;
            this.content = item.value;
            this.filterInput = item.text;
            this.isItemSelected = true;

            this.$emit('input', item.value);
            this.$emit('onChangeFilter', item);
        },
        resetSelection: function () {
            this.selectedItem = {};
            this.content = '';
            this.filterInput = '';
            this.isItemSelected = false;
            
            this.$emit('input', '');
            this.$emit('onChangeFilter', null);
            
            this.$nextTick(() => {
                this.$refs[`${this.id}`].focusInput();
            });
        },
        // methods
        setSelectedItem: function (value) {
            const filteredItem = this.dropdownList
                .filter(item => {
                    return (item.text == value);
                });

            if (filteredItem.length > 0) {
                this.selectItem(filteredItem[0]);
            }
        },
        // util
        itemVisible: function (item) {
            const currentName = item.text.trim().toLowerCase();
            const currentInput = this.filterInput.trim().toLowerCase();
            if (currentInput) {
                return currentName.indexOf(currentInput) >= 0;
            } else {
                return true;
            }
        }
    }
}
</script>
<style lang="scss">
@import "@/style/base/common.scss";
.filter-ddl-input {
    @include baseFilterInput('../../assets/icon/icon_dropdown.png');
    margin-top: 0 !important;
    .input-wrapper {
        .input-field {
            padding-left: 16px;
        }
    }
}
</style>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
.dropdown-filter {
    position: relative;
    width: 100%;

    .dropdown-input {
        .dropdown-selected {
            width: 100%;
            height: 45px;
            padding-left: 16px;
            padding-right: 40px;
            margin-bottom: 15px;
            border: 1px solid $a-gray-C4C4C4;
            border-radius: 100px;
            // background
            background-image: url('../../assets/icon/icon_dropdown.png'); //url('../../../assets/icon/icon_dropdown.png');
            background-color: #fff;
            background-repeat: no-repeat;
            background-position: center right 15px;
            background-size: 16px 9px;
            // font
            color: $a-gray-333333;
            font-size: 1.5rem;
            line-height: 1.8;

            @media (max-width: $max-width-mini-mobile) {
                font-size: 1.4rem;
                line-height: 2.2;
            }
        }

        .dropdown-disabled {
            width: 100%;
            height: 50px;
            padding-left: 16px;
            padding-right: 40px;
            margin-bottom: 15px;
            border: none;
            background: #f2f2f2;
            border-radius: 100px;
            // font
            color: #666666;
            font-size: 1.6rem;
            line-height: 1.8;

            @media (max-width: $max-width-mini-mobile) {
                font-size: 1.4rem;
                line-height: 2.2;
            }
        }
    }

    .dropdown-list {
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        width: 100%;
        max-height: 250px;
        margin-top: 4px;
        background-color: #ffffff;
        border: 1px solid #666666;
        border-radius: 8px;
        overflow-y: scroll;
        z-index: 100;
        
        .dropdown-item {
            display: flex;
            width: 100%;
            padding: 11px 16px;
            cursor: pointer;
            background-color: #ffffff;
            border-radius: 8px;
            // &:hover{
                
            // }
        }
    }
}
</style>